import { DisplayTable } from '@policoders/ds';
import PageHeader from '@shared/components/page-header';

import { useCashBook } from './cash-book.hook';

export const CashBookPage = () => {
  const { lines, tActions, tColumns, tHeaderButtons, handleEdit } = useCashBook();

  return (
    <>
      <PageHeader title="Livro caixa" />
      <DisplayTable
        actions={tActions}
        columns={tColumns}
        headerButtons={tHeaderButtons}
        lines={lines}
        groupLinesBy={'dateFormated'}
        onLineClick={handleEdit}
      />
    </>
  );
};
